
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.5 1.752h7a2.333 2.333 0 012.333 2.334v7a2.333 2.333 0 01-2.334 2.333h-7a2.333 2.333 0 01-2.333-2.333v-7a2.333 2.333 0 012.333-2.334zm8.03 10.365c.274-.274.428-.645.428-1.031v-7a1.458 1.458 0 00-1.459-1.459h-7c-.805 0-1.458.653-1.458 1.459v7a1.458 1.458 0 001.458 1.458h7c.387 0 .758-.154 1.031-.427z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.996 9.686a.44.44 0 01-.287-.108L4.355 8.413a.493.493 0 01-.053-.66.438.438 0 01.627-.076l1.049.901 3.021-2.923a.44.44 0 01.466-.153.487.487 0 01.139.851l-3.3 3.206a.436.436 0 01-.308.127z","fill":"#fff"}})])
          )
        }
      }
    